// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "desktop_NewBuildingSearchRoute" + "_" + "360cb18bd1c07e9e5089" + ".css";
};